import * as React from "react"
import { Grid } from "@mui/material"

import RetailersTrackedTable from "./Table"

export default function RetailersTrackedContent() {

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<RetailersTrackedTable />
		</Grid>
	</Grid>
}
